import React, { useState, useRef } from 'react';
import { Overlay, Popover } from 'react-bootstrap';

const TooltipInfoCard = ({ message, children, showLearnMore = false, link = '', learnMore = 'Learn More', placement = 'right' }) => {
    
    const [showInfo, setShowInfo] = useState(false);
    const iconRef = useRef(null);
    const timeoutRef = useRef(null);

    const handleMouseEnter = () => {
        clearTimeout(timeoutRef.current);
        setShowInfo(true);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setShowInfo(false);
        }, 100);
    };

    return (
        <div className="d-inline-block ml-1" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <span
                ref={iconRef}
                style={{ cursor: 'pointer' }}
                className="text-primary"
            >
                <i
                    className="fa fa-info-circle text-secondary ms-2"
                    style={{ fontSize: '1rem' }}
                ></i>
            </span>

            <Overlay
                target={iconRef.current}
                show={showInfo}
                placement={placement}
                rootClose
                onHide={() => setShowInfo(false)}
            >
                {(props) => (
                    <Popover {...props}>
                        <Popover.Body>
                            {message || children}
                            {showLearnMore && link && (
                                <a
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-block mt-2 text-primary text-decoration-underline"
                                >
                                    {learnMore}
                                </a>
                            )}
                        </Popover.Body>
                    </Popover>
                )}
            </Overlay>
        </div>
    );
};

export default TooltipInfoCard;
